import { type AccessSubject, hasExplicitPermission, hasRole } from './access'
import { permissions } from './permissions'
import { roleNames } from './roles'

/**
 * Determines whether a subject is allowed to use the admin "god mode" UI toggle.
 *
 * This is a client-side visibility gate only. It requires both the super-admin
 * role and the effective/inherited `users:impersonate` permission so that role
 * membership alone does not bypass the permission system.
 */
export const canUseGodMode = (subject: AccessSubject | null): boolean => {
  return (
    hasRole(subject, roleNames.superAdmin) &&
    hasExplicitPermission(subject, permissions.users.impersonate)
  )
}
